export const WARNING_MESSAGES_FR = {
    MISSING_EXPERIENCE: "Une ou plusieurs expériences identifiées dans la source sont absentes du brouillon.",
    INCOMPLETE_EXPERIENCE: "Une ou plusieurs expériences ont été récupérées partiellement.",
    AMBIGUOUS_EXPERIENCE_MATCH: "Certaines expériences sont présentes, mais leur rapprochement avec la source doit être vérifié.",
    UNCERTAIN_SOURCE_STRUCTURE: "La mise en page du document ne permet pas de confirmer automatiquement toutes les expériences.",
    EXPERIENCE_PERSISTENCE_MISMATCH: "Le nombre d'expériences enregistrées diffère du résultat validé.",
    EXPERIENCE_UI_MAPPING_MISMATCH: "Le nombre d'expériences affichées diffère du brouillon enregistré.",
    missing_experiences: "Certaines expériences professionnelles présentes dans le CV original n'ont pas été récupérées.",
    incomplete_source_experiences: "Certaines expériences professionnelles du CV original nécessitent une vérification.",
    no_exploitable_experiences: "Les expériences détectées ne contiennent pas encore assez d'informations exploitables.",
    experience_without_missions: "Une expérience professionnelle ne contient aucune mission détaillée.",
    missing_skills: "Certaines compétences techniques présentes dans le CV original n'ont pas été récupérées.",
    incoherent_chronology: "Chronologie à vérifier : certaines périodes d'expériences se chevauchent ou contiennent des dates contradictoires.",
    certifications_missing: "Certifications mentionnées dans le CV source mais non extraites.",
    summary_missing: "Profil / résumé candidat présent dans le CV source mais non extrait.",
    summary_too_short: "Le profil candidat extrait est particulièrement court.",
    education_missing: "Formation présente dans le CV source mais non extraite.",
    languages_missing: "Langues présentes dans le CV source mais non extraites.",
    skills_too_few: "Très peu de compétences détectées dans le document.",
    title_too_generic: "Titre du candidat générique à préciser.",
    too_many_sparse_experiences: "Certaines expériences professionnelles comportent peu de détails.",
    skills_count_too_high: "Nombre de compétences particulièrement élevé.",
    experiences_count_too_high: "Nombre d'expériences professionnelles élevé.",
    hallucinated_years_of_experience: "Années d'expérience sans mention explicite dans le texte source.",
    unmapped_content: "Certains éléments non classifiés ont été conservés dans le brouillon.",
    documentary_validation_blocked: "Une incohérence documentaire critique a été détectée dans le document original.",
    DOCUMENTARY_VALIDATION_FAILED: "Certaines informations nécessitent votre vérification dans le document source.",
    READY_WITH_WARNINGS: "CV exploitable avec avertissements documentaires.",
    CORRECTION_REQUIRED: "Certaines informations nécessitent votre vérification avant finalisation.",
};

export const AI_ERROR_MESSAGES_FR = {
    AI_BUDGET_REJECTED: "L'analyse IA est temporairement indisponible en raison d'une limite d'utilisation.",
    AI_CONFIGURATION_ERROR: "Le service d'analyse IA n'est pas correctement configuré. Contactez un administrateur.",
    AI_PROVIDER_UNAVAILABLE: "Le service d'analyse IA est momentanément indisponible. Veuillez réessayer.",
    AI_TIMEOUT: "L'analyse IA prend plus de temps que prévu. Veuillez réessayer.",
    AI_NOT_EXECUTED: "L'analyse IA n'a pas pu démarrer.",
    AI_FAILED: "Réponse IA invalide ou incomplète. Veuillez réessayer.",
    AI_UNAVAILABLE: "Service d'analyse IA momentanément indisponible.",
    DOCUMENTARY_VALIDATION_FAILED: "Le contrôle documentaire a identifié des éléments à vérifier dans le document source.",
    PIPELINE_INCOMPLETE: "Une étape obligatoire de la génération n'a pas abouti. Veuillez réessayer.",
    DOCLING_EXTRACTION_FAILED: "Le document n'a pas pu être analysé. Cause : erreur de lecture du fichier PDF ou document corrompu.",
    PDF_READ_ERROR: "Le document n'a pas pu être analysé. Cause : erreur de lecture du fichier PDF.",
    PDF_CORRUPT: "Le document n'a pas pu être analysé. Cause : fichier PDF corrompu ou illisible.",
    UNSUPPORTED_FILE_TYPE: "Format de document non supporté. Veuillez utiliser un format PDF, DOCX, PPTX ou image.",
    CV_MAPPING_FAILED: "Certaines données du CV n'ont pas pu être interprétées ou projetées dans le modèle Lenvia.",
    JOB_TIMEOUT: "Délai de traitement dépassé. Le serveur n'a pas pu terminer l'analyse dans le temps imparti.",
    MONGODB_PERSISTENCE_FAILED: "Échec de sauvegarde des données extraites en base de données. Veuillez réessayer.",
    SESSION_EXPIRED: "Votre session utilisateur a expiré. Veuillez vous reconnecter.",
    NETWORK_ERROR: "Erreur de connexion. Impossible de joindre le serveur.",
};

export const AI_ERROR_CAUSES_FR = {
    DOCLING_EXTRACTION_FAILED: "erreur de lecture du fichier PDF ou document corrompu.",
    PDF_READ_ERROR: "erreur de lecture du fichier PDF.",
    PDF_CORRUPT: "fichier PDF corrompu ou illisible.",
    UNSUPPORTED_FILE_TYPE: "format de fichier non supporté (utilisez PDF, DOCX, PPTX ou image).",
    AI_BUDGET_REJECTED: "limite de quota d'utilisation IA atteinte.",
    AI_PROVIDER_UNAVAILABLE: "indisponibilité momentanée du service IA (Gemini / Vertex AI).",
    AI_UNAVAILABLE: "indisponibilité momentanée du service IA.",
    AI_TIMEOUT: "dépassement du délai de réponse de l'analyse IA.",
    JOB_TIMEOUT: "dépassement du temps maximum alloué au traitement du document.",
    AI_FAILED: "réponse IA inexploitable ou structure documentaire non reconnue.",
    CV_MAPPING_FAILED: "incohérence entre les données extraites et le schéma de données.",
    DOCUMENTARY_VALIDATION_FAILED: "anomalie de fidélité documentaire critique détectée.",
    MONGODB_PERSISTENCE_FAILED: "échec d'enregistrement dans la base de données.",
    SESSION_EXPIRED: "session utilisateur inactive ou jeton d'authentification expiré.",
    NETWORK_ERROR: "problème de connexion réseau avec le serveur.",
};

/**
 * Returns a user-friendly French message for a given AI error code.
 * @param {string} errorCode
 * @returns {string}
 */
export const getAiErrorUserMessage = (errorCode) => {
    if (!errorCode) return "";
    const key = String(errorCode).trim().toUpperCase();
    return AI_ERROR_MESSAGES_FR[key] || "";
};

/**
 * Returns a specific user-friendly cause description for a given error code.
 * @param {string} errorCode
 * @returns {string}
 */
export const getAiErrorCause = (errorCode) => {
    if (!errorCode) return "";
    const key = String(errorCode).trim().toUpperCase();
    return AI_ERROR_CAUSES_FR[key] || "";
};

/**
 * Returns a human-friendly French message for a warning code or object.
 * Avoids exposing raw technical keys like 'certifications_missing' in the UI.
 * @param {string|object} warning
 * @returns {string}
 */
export const getWarningUserMessage = (warning) => {
    if (!warning) return "";
    if (typeof warning === "object") {
        if (warning.message) {
            if (Array.isArray(warning.experiences) && warning.experiences.length > 0) {
                return `${warning.message} (${warning.experiences.join(", ")})`;
            }
            return warning.message;
        }
        return WARNING_MESSAGES_FR[warning.code] || WARNING_MESSAGES_FR[warning.type] || warning.code || warning.type || "";
    }
    const key = String(warning).trim();
    return WARNING_MESSAGES_FR[key] || key;
};
